






















import EstimatePaymentMethodTable from "@/components/project/property/EstimatePaymentMethodTable.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    EstimatePaymentMethodTable
  }
})
export default class EstimatePaymentMethodListPage extends Vue {
  public created() {
    this.$store.dispatch("estimate_payment_method/init");
  }

  get initRows() {
    return this.$store.getters["estimate_payment_method/all"];
  }

  sort(data: unknown[]) {
    this.$store.dispatch("estimate_payment_method/sort", data);
  }

  async remove(id: number) {
    try {
      await this.$store.dispatch("estimate_payment_method/remove", id);
    } catch (e) {
      const msg =
        typeof e === "string"
          ? e
          : Array.isArray(e)
          ? e.join("\n")
          : "削除に失敗しました。";
      alert(msg);
    }
  }
}
